import React from 'react';

import { Card } from '../layout/Card.component';
import { Spacer } from '../spacing';
import { Heading } from '../typography';
import { BaseModal } from './BasicModal.component';
import LoadingIndicator from './LoadingIndicator.component';

interface ConfirmationModalProps {
  isLoading?: boolean;
  children: React.ReactNode;
  title: string;
  onRequestClose: () => void;
  isOpen: boolean;
  className?: string;
}

export const ConfirmationModal: React.FC<ConfirmationModalProps> = (props) => {
  if (props.isLoading) {
    // Always open, no closing
    return (
      <BaseModal onRequestClose={undefined} isOpen={true} centered>
        <Card
          maxWidth="420px"
          rounded
          minWidth="300px"
          className={props.className}
        >
          <LoadingIndicator style="dark" />
        </Card>
      </BaseModal>
    );
  }

  return (
    <BaseModal
      onRequestClose={props.onRequestClose}
      isOpen={props.isOpen}
      centered
    >
      <Card maxWidth="420px" rounded className={props.className}>
        <Heading as="h6" style="heading6">
          {props.title}
        </Heading>
        <Spacer s="xxs" />

        {props.children}
      </Card>
    </BaseModal>
  );
};
